/**
 * ShortcutsDialog Component
 *
 * Displays all available keyboard shortcuts in a simple table.
 * Triggered by pressing "?" when not focused in an input field.
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface ShortcutsDialogProps {
  open: boolean;
  onClose: () => void;
}

interface ShortcutEntry {
  keys: string[];
  description: string;
}

const shortcuts: ShortcutEntry[] = [
  { keys: ['Ctrl+K'], description: 'Abrir paleta de comandos' },
  { keys: ['Alt+1'], description: 'Ir para Dashboard' },
  { keys: ['Alt+2'], description: 'Ir para Pacientes' },
  { keys: ['Alt+3'], description: 'Ir para Calendário' },
  { keys: ['Alt+4'], description: 'Ir para Sessões' },
  { keys: ['?'], description: 'Mostrar atalhos de teclado' },
  { keys: ['Esc'], description: 'Fechar diálogo / paleta' },
];

const ShortcutsDialog: React.FC<ShortcutsDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        Atalhos de Teclado
        <IconButton onClick={onClose} size="small" aria-label="Fechar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Atalho</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Acao</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shortcuts.map((shortcut, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                      {shortcut.keys.map((key) => (
                        <Chip
                          key={key}
                          label={key}
                          size="small"
                          variant="outlined"
                          sx={{
                            fontFamily: 'monospace',
                            fontSize: '0.75rem',
                            height: 24,
                          }}
                        />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell>{shortcut.description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default ShortcutsDialog;
